import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { OFAC_MATCH_BASE_PATH } from '../../../../../../../../../features/watchlist/ofac/match/ofac-match-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/match/_match')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'ofac-match-list',
        label: 'OFAC',
        to: OFAC_MATCH_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
